class Hero {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.item = self.elem.querySelector('[data-hero-item]');
    }

    init() {
        let self = this;

        self.checkHeight();
    }

    checkHeight() {
        let self = this;

        if (self.elem.offsetHeight > window.innerHeight) {
            self.elem.classList.add('is-full');
        } else {
            self.elem.classList.remove('is-full');
        }
    }
}

export default Hero;
